import axios from "axios";

export const state = {
    reportmemberfeespermembers: [],
};

export const getters = {
    reportmemberfeespermembers: state => state.reportmemberfeespermembers,
};

export const mutations = {
    setReportMemberfeesPerMember(reportmemberfeespermembers, newValue) { state.reportmemberfeespermembers = newValue},
};

export const actions = {
    async fetchReportMemberfees({ commit }) {
        await axios.get('/reportmembershipfee').then(res => {
            commit('setReportMemberfeesPerMember', res.data.membershipfees)
        })
    },
    async filterReportMemberfees({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportmemberfees";
        await axios.post(url, formData).then((response) => {
            commit('setReportMemberfeesPerMember', response.data.membershipfees)
        })
    },
};
